"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = __importDefault(require("crypto"));
function default_1(secret, options) {
    if (!secret ||
        (typeof secret !== 'string' && typeof secret !== 'function')) {
        throw new TypeError(`Invalid value provided for property secret. Expected non-empty string or function but got '${secret}' (type: ${typeof secret})`);
    }
    if (typeof options.algorithm !== 'string' ||
        !crypto_1.default.getHashes().includes(options.algorithm)) {
        throw new TypeError(`Invalid value provided for property options.algorithm. Expected value from crypto.getHashes() but got ${options.algorithm} (type: ${typeof options.algorithm})`);
    }
    if (!options.identifier || typeof options.identifier !== 'string') {
        throw new TypeError(`Invalid value provided for property options.identifier. Expected non-empty string but got '${options.identifier}' (type: ${typeof options.identifier})`);
    }
    if (!options.header || typeof options.header !== 'string') {
        throw new TypeError(`Invalid value provided for property options.header. Expected non-empty string but got '${options.header}' (type: ${typeof options.header})`);
    }
    if (!options.maxInterval ||
        typeof options.maxInterval !== 'number' ||
        Number.isNaN(options.maxInterval)) {
        throw new TypeError(`Invalid value provided for property options.maxInterval. Expected number but got '${options.maxInterval}' (type: ${typeof options.maxInterval})`);
    }
    if (typeof options.minInterval !== 'number' ||
        Number.isNaN(options.minInterval) ||
        options.minInterval < 0) {
        throw new TypeError(`Invalid value provided for optional property options.minInterval. Expected positive number but got '${options.minInterval}' (type: ${typeof options.minInterval})`);
    }
}
exports.default = default_1;
